import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import { KeyValuePairs } from 'components/ideal-core-ui'
import s from './ReplaceFileModal.scss'

const ReplaceFileModal = ({
  showReplaceFileModal,
  toggleReplaceFileModal,
  upload,
  replaceFile,
  proposalName,
  showError,
  isCreate
}) => (
  <>
    <Modal
      keyboard={false}
      backdrop="static"
      isOpen={showReplaceFileModal}
      toggle={toggleReplaceFileModal}
      className={s.proposalModal}
      size="lg"
    >
      <ModalHeader toggle={toggleReplaceFileModal} className={s.modalHeader}>
        {isCreate ? 'Add' : 'Replace'} File for Proposal
      </ModalHeader>
      <ModalBody>
        <p>
          You are {isCreate ? 'adding a' : 'replacing the'} file for proposal &apos;{proposalName}
          &apos;
        </p>
        {showError && <p className={s.error}>You have to choose a file for the proposal</p>}
        <KeyValuePairs
          pairs={[
            {
              key: '*Upload File',
              value: <input type="file" onChange={upload} className={s.fileInput} />
            }
          ]}
        />
      </ModalBody>
      <ModalFooter>
        <Button className={s.saveBtn} onClick={replaceFile}>
          Save
        </Button>
        <Button color="secondary" onClick={toggleReplaceFileModal}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  </>
)

export default ReplaceFileModal
